export const version = "strings/5.0.9";
//# sourceMappingURL=_version.js.map